export const PERSIAN_NUMBERS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

export const PERSIAN_MONTHS = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
];

export const ROMANIAN_MONTHS = [
    "Ianuarie",
    "Februarie",
    "Martie",
    "aprilie",
    "Mai",
    "Iunie",
    "Iulie",
    "August",
    "Septembrie",
    "Octombrie",
    "Noiembrie",
    "Decembrie",
];

export const PERSIAN_WEEK_DAYS = [
    {
        name: "شنبه",
        short: "ش",
    },
    {
        name: "یکشنبه",
        short: "ی",
    },
    {
        name: "دوشنبه",
        short: "د",
    },
    {
        name: "سه شنبه",
        short: "س",
    },
    {
        name: "چهارشنبه",
        short: "چ",
    },
    {
        name: "پنجشنبه",
        short: "پ",
    },
    {
        name: "جمعه",
        short: "ج",
        isWeekend: true,
    },
];

export const GREGORIAN_WEEK_DAYS = [
    {
        name: "Sunday",
        short: "DU",
        isWeekend: true,
    },
    {
        name: "Monday",
        short: "LU",
    },
    {
        name: "Tuesday",
        short: "MA",
    },
    {
        name: "Wednesday",
        short: "MI",
    },
    {
        name: "Thursday",
        short: "JOI",
    },
    {
        name: "Friday",
        short: "VI",
    },
    {
        name: "Saturday",
        short: "SÂ",
        isWeekend: true,
    },
];

export const MINIMUM_SELECTABLE_YEAR_SUBTRACT = 100;

export const MAXIMUM_SELECTABLE_YEAR_SUM = 50;

export const TYPE_SINGLE_DATE = "SINGLE_DATE";
export const TYPE_RANGE = "RANGE";
export const TYPE_MUTLI_DATE = "MUTLI_DATE";
